export const Features = {
  abdicationCancellationRight: 'abdicationCancellationRight',
  accountNumberValidation: 'accountNumberValidation',
  additionalAccount: 'additionalAccount',
  askForKundennummer: 'askForKundennummer',
  asyncProcessing: 'asyncProcessing',
  checkCreditorChange: 'checkCreditorChange',
  footerContact: 'footerContact',
  foreignResidenceCheck: 'foreignResidenceCheck',
  hasFeedbackModal: 'hasFeedbackModal',
  hasStatusPage: 'hasStatusPage',
  infoIconPath: 'infoIconPath',
  investmentAccountUrl: 'investmentAccountUrl',
  isTinRequired: 'isTinRequired',
  ownAccountTransferPrechecked: 'ownAccountTransferPrechecked',
  prefillBankCode: 'prefillBankCode',
  proceedsOnClearingAccount: 'proceedsOnClearingAccount',
  promotionImage: 'promotionImage',
  promotionLink: 'promotionLink',
  securitiesAccountUrl: 'securitiesAccountUrl',
  showBlzInput: 'showBlzInput',
  showFinanceType: 'showFinanceType',
  showFinanceTypeInfo: 'showFinanceTypeInfo',
  showFinoLogoInHeader: 'showFinoLogoInHeader',
  showHeadline: 'showHeadline',
  showHelpItem: 'showHelpItem',
  showNewPortfolioNeededInfo: 'showNewPortfolioNeededInfo',
  showSignaturePad: 'showSignaturePad',
  showStartOpenSecuritiesAccountInfo: 'showStartOpenSecuritiesAccountInfo',
  transferTypes: 'transferTypes',
  userEmail: 'userEmail',
  USWithholdingTaxCheck: 'USWithholdingTaxCheck',
};



// WEBPACK FOOTER //
// ./src/app/common/config/feature.constants.js